import { combineReducers } from '@reduxjs/toolkit';
import { all } from 'redux-saga/effects';
import { addressReducer as address, addressSagas } from './address';
import { adminSalesReducer as adminSales, adminSalesSagas } from './adminSales';
import { authReducer as auth, authSagas } from './auth';
import { bigCommerceReducer as bigCommerce, bigCommerceSagas } from './bigCommerce';
import { businessEnitityReducer as businessEntity, businessEntitySagas } from './businessEntity';
import { cartsReducer as carts, cartsSagas } from './carts';
import { complianceSalesReducer as complianceSales, complianceSalesSagas } from './complianceSales';
import { configReducer as config } from './config';
import { contactReducer as contacts, contactSagas } from './contact';
import { coOpReducer as coOp, coOpSagas } from './coOp';
import { coreReducer as core, coreSagas } from './core';
import { dashboardReducer as dashboard, dashboardSagas } from './dashboard';
import { dealerReducer as dealer, dealerSagas } from './dealer';
import { departingSoonReducer as departingSoon, departingSoonSagas } from './departingSoon';
import { displaySagas, displaysReducer as displays } from './displays';
import { dpNewsFeedReducer as dpNewsFeed, dpNewsFeedSagas } from './dpNewsFeed';
import { filesReducer as files, filesSagas } from './files';
import { filtersReducer as filters } from './filters';
import { inventoryReducer as inventory, inventorySagas } from './inventory';
import { linksReducer as links, linksSagas } from './links';
import { logisticsReducer as logistics, logisticsSagas } from './logistics';
import {
  logisticsSyncChangesReducer as logisticsSyncChanges,
  logisticsSyncChangesSagas
} from './logistics/logisticsSyncChanges';
import { lookupSagas, lookupsReducer as lookups } from './lookups';
import { meReducer as me } from './me';
import { newDealerReducer as newDealer, newDealerSagas } from './newDealer';
import { orderReducer as order, orderSagas } from './order';
import { productsReducer as products } from './products';
import { programsReducer as programs, programsSagas } from './programs';
import { prospectSagas, prospectsReducer as prospects } from './prospects';
import { salesCallReducer as salesCall, salesCallSagas } from './salesCalls';
import { salesRepReducer as salesRep, salesRepSagas } from './salesRep';
import { targetedCatalogReducer as targetedCatalog, targetedCatalogSagas } from './targetedCatalog';
import { uiReducer as ui } from './ui';
import { unallocatedProductsReducer as unallocatedProducts, unallocatedProductsSagas } from './unallocatedProducts';
import { usersReducer as users } from './users';
import { warehousePermissionsReducer as warehousePermissions, warehousePermissionsSagas } from './warehousePermissions';

export const reducers = combineReducers({
  address,
  adminSales,
  auth,
  bigCommerce,
  businessEntity,
  carts,
  complianceSales,
  config,
  contacts,
  coOp,
  core,
  dashboard,
  dealer,
  departingSoon,
  displays,
  dpNewsFeed,
  files,
  filters,
  inventory,
  links,
  logistics,
  logisticsSyncChanges,
  lookups,
  me,
  newDealer,
  order,
  products,
  programs,
  prospects,
  salesCall,
  salesRep,
  targetedCatalog,
  ui,
  unallocatedProducts,
  users,
  warehousePermissions
});

export type IState = ReturnType<typeof reducers>;

export function* rootSaga() {
  yield all([
    ...addressSagas,
    ...adminSalesSagas,
    ...authSagas,
    ...bigCommerceSagas,
    ...businessEntitySagas,
    ...cartsSagas,
    ...coOpSagas,
    ...complianceSalesSagas,
    ...contactSagas,
    ...coreSagas,
    ...dashboardSagas,
    ...dealerSagas,
    ...departingSoonSagas,
    ...displaySagas,
    ...dpNewsFeedSagas,
    ...filesSagas,
    ...inventorySagas,
    ...linksSagas,
    ...logisticsSagas,
    ...logisticsSyncChangesSagas,
    ...lookupSagas,
    ...newDealerSagas,
    ...orderSagas,
    ...programsSagas,
    ...prospectSagas,
    ...salesCallSagas,
    ...salesRepSagas,
    ...targetedCatalogSagas,
    ...unallocatedProductsSagas,
    ...warehousePermissionsSagas
  ]);
}
